<div class="info">
    <nb-card [status]="status">
        <nb-card-header> <i class="fa fa-exclamation-triangle" aria-hidden="true"></i> {{ header }}
        </nb-card-header>
        <nb-card-body>
            <p> <b> {{ primaryText }}  </b> </p>
            <p *ngIf="secondaryText"> <i class="fa fa-arrow-right text-secondary"></i> {{ secondaryText }}
            </p>
        </nb-card-body>
        <nb-card-footer>
            <div class="row float-right">
                <div class="col-12 ">
                    <button [status]="status" nbButton (click)="close();">{{'Okay' | translate}}</button>
                </div>
            </div>
        </nb-card-footer>
    </nb-card>
</div>